import React, { memo } from 'react'

import { trackSettingsInteraction } from 'Pods/ThreeDStudio/Services/studioTracker'
import GenericPolygonTypeSelector from 'Pods/ThreeDStudio/Shared/GenericPolygonTypeSelector/GenericPolygonTypeSelector'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setPolygonType } from 'Pods/ThreeDStudio/Store/actions/modelSettings'
import { POLYGON_TYPE } from 'Pods/ThreeDStudio/Store/constants'

const handlePolygonTypeClick = (polygonType) => {
  trackSettingsInteraction('polygon_type', polygonType)
  setPolygonType(polygonType)
}

const handleQuadrilateralClick = () => handlePolygonTypeClick(POLYGON_TYPE.QUADRILATERAL)
const handleTriangleClick = () => handlePolygonTypeClick(POLYGON_TYPE.TRIANGLE)

function PolygonTypeSelector() {
  const isSmartLowPoly = useThreeDStudioStore(state => state.modelSettings.isSmartLowPoly)

  return (
    <GenericPolygonTypeSelector
      handleQuadrilateralClick={handleQuadrilateralClick}
      handleTriangleClick={handleTriangleClick}
      sliceName="modelSettings"
      storeSchemaKey="generationModelSchema"
      forceDisabled={isSmartLowPoly}
    />
  )
}

export default memo(PolygonTypeSelector)
